<template>
  <v-container>
    <v-card class="mx-auto my-4" max-width="400">
      <v-card-title>Login</v-card-title>
      <v-card-text>
        <v-form ref="loginForm" v-model="valid" lazy-validation>
          <v-text-field
            label="Username"
            v-model="username"
            :rules="[(v) => !!v || 'Username is required']"
            required
          ></v-text-field>
          <v-text-field
            label="Password"
            v-model="password"
            :rules="[(v) => !!v || 'Password is required']"
            type="password"
            @keyup.enter="handleLogin"
            required
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!valid || loading"
          color="primary"
          @click="handleLogin"
        >
          Login
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { useAuthStore } from "@/stores/authStore";

export default {
  name: "LoginPage",
  data() {
    return {
      username: "",
      password: "",
      valid: false,
      loading: false,
    };
  },
  methods: {
    async handleLogin() {
      if (!this.$refs.loginForm.validate()) {
        return;
      }
      this.loading = true;
      const authStore = useAuthStore();
      try {
        await authStore.login(this.username, this.password);
        // On successful login, redirect to the protected page or Home.
        this.$router.push({ name: "AdminPage" });
      } catch (error) {
        alert("Login failed: " + error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Add any custom styling as needed */
</style>
